<template>
<v-navigation-drawer
    v-model="drawer"
    width="350"
    app
    temporary
    right
    >
    <v-toolbar flat color="black" dark>
      <v-list>
        <v-list-tile>
          <v-list-tile-title class="title">
            Test Utterance
          </v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-toolbar>
    <v-layout row wrap>
      <v-flex xs12 class="mt-3">
        <v-text-field
            v-model="input.q"
            :loading="loaders.search"
            placeholder="Type a test utterance"
            append-icon="bug_report"
            @keydown.enter="testQuery"
            outline />
            <v-flex xs12 style="padding-right: 0 !important; margin-right: 0">
              <v-btn color="black" :loading="loaders.search" style="margin-top: -5px; float: right;" @click="testQuery" dark>Test</v-btn>
            </v-flex>
        </v-flex>
    </v-layout>
    <v-layout
        v-if="result"
        row
        wrap>
      <v-flex xs12 class="mt-3">
        <v-card
            flat
            color="grey lighten-2"
            class="border-radius-standard">
          <v-card-text>
            <p class="title">
            <b>Intent:</b> {{ result.intent }}
            </p>
            <p :class="[result.valid ? 'success--text' : 'error--text', 'house-keeper-y']">
              Score: {{ result.score.toFixed(3) }}
            </p>
            <div v-if="result.entities && result.entities.length" class="py-0 my-0">
              <p class="house-keeper-y">Entities({{ result.entities.length }}) : </p>
              <v-chip
                v-for="(entity, e) in result.entities"
                v-text="entity.type + '= ' + entity.entity"
                :color="entity.valid ? 'error' : 'success'"
                class="px-2"
                outline />
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
</v-navigation-drawer>
</template>

<script>
export default {

  name: 'TestPrediction',

  data () {
    return {
      drawer: false,
      input: {
        q: ''
      },
      loaders: {
        search: false
      },
      result: null
    }
  },
  mounted() {
    //
  },
  computed: {
    selectedApp() {
      return this.$store.state.nlp.selectedApp.id
    }
  },
  methods: {
    toggleDrawer(status = undefined) {
      if(status === undefined) {
        this.drawer = !this.drawer
      } else this.drawer = status
    },
    testQuery() {
      this.loaders.search = true
      this.$http_nlp({
        url: `/apps/${this.selectedApp}/test-prediction`,
        method: 'get',
        params: this.input
      }).then(res => {
        this.loaders.search = false
        this.result= res.data
      }).catch(()=>{
        this.loaders.search = false
      })
    }
  }
}
</script>

<style lang="css" scoped>
.house-keeper-y {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
</style>